import { render, staticRenderFns } from "./default.vue?vue&type=template&id=55d0ecd2"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SideDrawer: require('C:/Visual Studio .NET Projects/Child Advocates/Timeclock/Timeclock.UI/components/side-drawer.vue').default})
